import actions from './actions'

const initialState = {
  extensionsAllList: [],
  extensionsInstalledList: [],
  sentManualIntentExtensionIds: [],
  extensionsActive: [],
  extensionsTypeActive: 'all',
  extensionSearchText: '',
  areExtensionsLoading: false,
}

export default function extensionsReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
